import { defineStore } from 'pinia';
import APIFactory from '../../api/APIFactory';
import { api } from '../../api/axios';

export const useAuthStore = defineStore('auth', {
  state: () => ({
    user: null,
    token: localStorage.getItem('token') || null,
    userTypes: {
      admin: { level: 'admin', pass: '1234' },
      mAudi: { level: 'manage', inst: 'audi', pass: '1234' },
      eAudi: {
        level: 'employee',
        inst: 'audi',
        affil: '8234567890123456789',
        pass: '1234'
      },
      mCarls: { level: 'manage', inst: 'carls', pass: '1234' },
      eCarls: {
        level: 'employee',
        inst: 'carls',
        affil: '9234567890123456789',
        pass: '1234'
      }
    },
    email: null,
    userType: null,
    userName: null,
    role: null,
    defaultRoute: null,
    permissions: null, // Aquí se almacenan los permisos
    userLogged: null,
    id_institution: null,
    institutionsList: false,
    storeList: false,
    store: null,
    institution: null
  }),
  getters: { isAuthenticated: (state) => !!state.token },
  actions: {
    setUser(userLogged) {
      this.user = userLogged;
    },
    setToken(token) {
      this.token = token;
    },
    async login(email, password, $router) {
      try {
        const { data } = await api.post('/login', { email, password });

        this.token = data.response.data.token;
        localStorage.setItem('token', this.token);

        // Llamar setValidation para obtener info del usuario real
        await this.setValidation($router);

        return data.response;
      } catch (error) {
        console.error('Error during login:', error);
        throw error;
      }
    },
    async setValidation($router) {
      try {
        const response = await APIFactory.post({
          path: '/verify-token',
          setToken: true
        });

        const data = response?.data?.response?.data;

        if (!data) {
          throw new Error('No se recibió información del usuario');
        }

        // Guardar datos del usuario desde el backend
        this.email = data.email;
        this.userName = data.user;
        this.userType = data.userType;
        this.permissions = data.permissions || {};

        this.store = data.store || null;
        this.institution = data.institution || null;

        this.storeList = data.storeList || false;
        this.institutionsList = data.institutionsList || false;

        // Guardar el usuario completo
        this.setUser(data);
        localStorage.setItem('user', JSON.stringify(data));

        // Determinar la ruta inicial basada en permisos
        const routePriority = [
          { name: 'dashboard', module: 'Dashboard', permission: 'list' },
          { name: 'reports', module: 'Reports', permission: 'list' },
          { name: 'cashRegister', module: 'CashRegister', permission: 'list' },
          { name: 'users', module: 'Users', permission: 'list' },
          { name: 'profiles', module: 'Profiles', permission: 'list' }
        ];

        let defaultRoute = 'dashboard';
        for (const route of routePriority) {
          if (this.hasPermission(route.module, route.permission)) {
            defaultRoute = route.name;
            break;
          }
        }

        $router.push({ name: defaultRoute });
      } catch (error) {
        localStorage.removeItem('token');
        $router.push({ name: 'login' });
        console.error('Error en validación de sesión:', error);
        throw error;
      }
    },
    async logout(router) {
      try {
        await APIFactory.post({ path: '/logout', setToken: true });
        this.user = null;
        this.token = null;
      } catch (error) {
        // eslint-disable-next-line
      } finally {
        localStorage.removeItem('token');
        router.push({ name: 'login' });
      }
    },
    async recoverPassword(recoverEmail) {
      try {
        const response = await APIFactory.post({
          path: '/recoverPassword',
          body: {
            ...recoverEmail
          },
          setToken: false
        });

        return response.data;
      } catch (error) {
        console.error('Error en recuperación de contraseña:', error);
        throw error;
      }
    },
    async validateUuid(email, uuid) {
      try {
        const response = await APIFactory.post({
          path: '/validateUuid',
          body: {
            email,
            uuid
          },
          setToken: false
        });

        return response.data;
      } catch (error) {
        console.error('Error en recuperación de contraseña:', error);
        throw error;
      }
    },
    async changePassword(payload) {
      try {
        const newPass = payload.body.newPassword;
        const oldPassword = payload.body.oldPassword;
        const { data } = await api.post('/changePassword', {
          oldPassword: oldPassword,
          newPassword: newPass,
          email: this.email
        });
        return data;
      } catch (error) {
        console.error('Error al cambiar la contraseña:', error);
        throw error;
      }
    },
    async changePasswordByUuid(payload) {
      try {
        const newPass = payload.body.new;
        const email = payload.body.email;
        const uuid = payload.body.uuid_confirmation;
        const { data } = await api.post('/changePasswordByUuid', {
          newPassword: newPass,
          email,
          uuid: uuid
        });
        return data;
      } catch (error) {
        console.error('Error al cambiar la contraseña:', error);
        throw error;
      }
    },
    async oktaLogin() {
      try {
        await APIFactory.get({ path: '/login/okta' });
      } catch (error) {
        console.error('Error al cambiar la contraseña:', error);
        throw error;
      }
    },

    hasPermission(pathOrModule, permission) {
      if (!this.permissions) {
        return false;
      }
      if (pathOrModule.includes('.')) {
        const [moduleName, submoduleName] = pathOrModule.split('.');
        const module = this.permissions[moduleName];
        if (!module?.submodules) {
          return false;
        }
        const targetSubmodule = module.submodules.find(
          (sub) => sub.name === submoduleName
        );
        return targetSubmodule?.actions?.includes(permission) ?? false;
      } else {
        const moduleName = pathOrModule;
        const module = this.permissions[moduleName];
        if (!module) {
          return false;
        }
        return (
          module.actions?.includes(permission) ||
          module.options?.includes(permission)
        );
      }
    }
  }
});
